import { Introduction } from '@/components/introduction';
import { Button } from '@/components/button';
import { Search2a } from '../elements/search-2a';
import classNames from 'classnames';

export const JobSearch2a = ({
    settings,
    introduction,
    attr,
    talent_community,
    button,
    filters,
}) => {
    return (
        <section
            className={classNames('section jobsearch', {
                ...settings,
            })}
            {...attr}
        >
            <div className="container">
                <Introduction {...introduction} />
                <div className="grid grid-md-12">
                    <div className="col-md-12">
                        <Search2a
                            filters={filters}
                            talent_community={talent_community}
                        />
                        {button && (
                            <Button
                                className={'jobsearch__cta'}
                                btn_style={button.btn_style}
                                cta_link={button.cta_link}
                            >
                                {button.cta_text}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
